import React from "react";
import "../style/footer.css";
import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import { GrInstagram } from "react-icons/gr";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IoLocation } from "react-icons/io5";
import { IoIosTime } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { LuSparkle } from "react-icons/lu";
import imgLogoWhite from "../images/Logorein-01.svg";

const serviceLinks = [
  { to: "/büroreinigung",          label: "Büroreinigung" },
  { to: "/glasundfensterreinigung", label: "Glas und Fensterreinigung" },
  { to: "/fassadenreinigung",      label: "Fassadenreinigung" },
  { to: "/treppenhausreinigung",   label: "Treppenhausreinigung" },
  { to: "/wohnungsreinigung",      label: "Wohnungsreinigung" },
  { to: "/bauabschlussreinigung",  label: "Bauendreinigung" },
  { to: "/umzugsreinigung",        label: "Umzugsreinigung" },
  { to: "/hochdruckreinigung",     label: "Hochdruckreinigung" },
  { to: "/",                       label: "Gewerbereinigung" },
];

const contactItems = [
  { icon: <IoLocation  style={{ width: 20, height: 20 }} />, text: "Düsseldorf, Germany" },
  { icon: <IoIosTime   style={{ width: 20, height: 20 }} />, text: "Geöffnet von 08:00 – 18:00 Uhr" },
  { icon: <MdEmail     style={{ width: 18, height: 18 }} />, text: "info@rein-cleaning.de" },
  { icon: <FaPhoneAlt  style={{ width: 15, height: 15 }} />, text: "+491742500990" },
];

function Footer() {
  return (
    <div className="container-footer-main">
      <div className="footer-container">
        <div className="footer-box">

          {/* ── BRAND ── */}
          <div className="footer-column first-box">
            <LazyLoadImage src={imgLogoWhite} className="logo-white-footer" alt="Rein Logo" />
            <Typography
              variant="body2"
              className="body-text-footer"
              sx={{ color: "var(--textColor)", fontSize: "15px", marginTop: "8px" }}
            >
              Glas und Gebäudereinigung
            </Typography>
          </div>

          {/* ── SERVICES ── */}
          <div className="footer-column">
            <span className="header-link">Dienstleistungen</span>
            {serviceLinks.map((s, i) => (
              <Link key={i} to={s.to} className="footer-link hover-link">
                <LuSparkle style={{ color: "var(--mainColorLight)", fontSize: 12, flexShrink: 0 }} />
                {s.label}
              </Link>
            ))}
          </div>

          {/* ── CONTACT ── */}
          <div className="footer-column">
            <span className="header-link">Kontakte</span>
            {contactItems.map((c, i) => (
              <Typography
                key={i}
                variant="body2"
                className="footer-link"
                sx={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <span style={{ color: "var(--mainColorLight)", flexShrink: 0 }}>{c.icon}</span>
                {c.text}
              </Typography>
            ))}
          </div>

        </div>

        {/* ── SOCIAL + BOTTOM ── */}
        <div className="social">
          <a href="https://www.instagram.com/rein.cleaning?igsh=a29sYnM0dGMwZ29p"
             className="link-icon-social" target="_blank" rel="noreferrer" aria-label="Instagram">
            <GrInstagram />
          </a>
          <a href="https://www.facebook.com/people/REIN-Glas-und-Geb%C3%A4udereinigung/61557904580806/"
             className="link-icon-social" target="_blank" rel="noreferrer" aria-label="Facebook">
            <FaFacebook />
          </a>
          <a href="https://www.twitter.com"
             className="link-icon-social" target="_blank" rel="noreferrer" aria-label="Twitter">
            <FaXTwitter />
          </a>
        </div>

        <div className="footer-bottom-bar">
          © {new Date().getFullYear()} Rein Glas und Gebäudereinigung. Alle Rechte vorbehalten.
        </div>

      </div>
    </div>
  );
}

export default Footer;